import notification from '@/api/notification-schedule'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {},
  notification_types: [],
  notification_params: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_NOTIFICATION_TYPES(state, data) {
    state.notification_types = data
  },
  SET_NOTIFICATION_PARAMS(state, data) {
    state.notification_params = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return notification.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return notification.store(data)
  },
  update(context, data) {
    return notification.update(data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await notification.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  async dataBeforeCreate(context) {
    if (!context.state.notification_types.length > 0) {
      let response = await notification.notificationTypes()
      context.commit('SET_NOTIFICATION_TYPES', response)
    }
  }
}
